'use client';

import { DialogContent } from '@/components/ui/overlay/dialog';
import { cn } from '@/lib/ui/utils';
import type { ComponentProps } from 'react';

/**
 * 给 CMS 风格弹窗统一挂上 CMS 主题作用域。
 * 这样弹窗不管出现在 CMS 页面里，还是普通页面里，
 * 根节点都能稳定拿到 CMS token。
 */
export function CmsOverlayDialogContent({
  className,
  ...props
}: ComponentProps<typeof DialogContent> & {
  positionerClassName?: string;
  showCloseButton?: boolean;
}) {
  return (
    <DialogContent
      className={cn('cms-theme cms-theme-standard', className)}
      {...props}
    />
  );
}
